export enum WorkShiftDayType {
  FROM_GLOBAL_CALENDAR = 0,
  WORKING = 1,
  HOLIDAY = 2,
  DAY_OFF = 3,
}
